import { useState,useEffect } from "react";
import { Nav, NavLink, NavMenu, HamburgerButton, HeadingStyle, ResponsiveNav } from "./NavElements";
import { googleLogout, useGoogleLogin } from '@react-oauth/google';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Button } from "react-bootstrap";
import { deleteUser } from "../actions/auth";
import PropTypes from "prop-types";
import { connect } from "react-redux";
const  NavBar= ({deleteUser,isAuthenticated}) =>{

  const [responsiveNavState, setResponsiveNavState] = useState(false);

  function reportWindowSize() {
    if (window.innerWidth > 600) setResponsiveNavState(false);
  }

  // Reporting screen size
  window.onresize = reportWindowSize;

  // move to top left corner 
  window.onscroll = function () {
    if (responsiveNavState === true) window.scrollTo(0, 0);
  };

  // function for alternating value of responsiveNavState 
  const hamburgerHandler = () => {
    setResponsiveNavState((prev) => {
      return !prev;
    });
  };

  // Initialising animation on scroll
  useEffect(()=>{
    AOS.init({
      duration:500,
    });
  },[]);
  const logout = () => {
     deleteUser();
     localStorage.removeItem("token");
};
  return (
    <>
      <Nav >
        <NavLink to="/">
          <h1 style={{ fontSize: "35px" }}>
            Place<HeadingStyle>mentor</HeadingStyle>
          </h1>
        </NavLink>
        <HamburgerButton onClick={hamburgerHandler} />
        <NavMenu  data-aos="fade-down-up">
          <NavLink to="/insight">Insights</NavLink>
          <NavLink to="/stats">Statistics</NavLink>
       {isAuthenticated&&   <NavLink to="/" onClick={logout}>
          Logout
        </NavLink>}
        </NavMenu>
      </Nav>
      <ResponsiveNav className={`${responsiveNavState ? "open" : ""}`}>
        <NavLink to="/" onClick={hamburgerHandler}>
          Home
        </NavLink>
        <NavLink to="/insight" onClick={hamburgerHandler}>
          Insights
        </NavLink>
        <NavLink to="/stats" onClick={hamburgerHandler}>
          Statistics
        </NavLink>
       {isAuthenticated&& <Button onClick={logout}   >
          Logout
        </Button>}
      </ResponsiveNav>
    </>
  );
}
NavBar.propTypes={
  deleteUser:PropTypes.func.isRequired,
  
  
  isAuthenticated:PropTypes.bool
}
const mapStateToProps=state=>({
  isAuthenticated:state.auth.isAuthenticated

})
export default connect(mapStateToProps,{deleteUser}) (NavBar);

 
